import Vue from 'vue'

const state = {
}

const getters = {
}

const actions = {
    getEventFromId: ({ commit, rootState }, eventId) => {
        return axios.get('/api/Event/GetById', {
            params:{
                supplierId: rootState.user.account.supplierId,
                eventId: eventId,
            }
        }).then(response => {
            return response
        })
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/events.js